import FrameworkUtils from 'utils/framework';
import { Box, Flex } from 'components/ui';
import {
    space, fontSizes, lineHeights, colors
} from 'style/config';
import Markdown from 'components/Markdown/Markdown';
import convertMarkdownLinksToJiraFormat from 'ai/utils/convertMarkdownLinksToJiraFormat';
import { isGenAINewUIEnabledWithRCPS } from 'ai/utils/aiBeautyChat';

const { wrapFunctionalComponent } = FrameworkUtils;

const MESSAGE_TYPES = {
    USER_QUERY: 'sent',
    USER_QUERY_RESPONSE: 'received'
};

function Message(props) {
    const { message } = props;
    const type = MESSAGE_TYPES[message.message_type || message.response_type];
    const isGenAINewUIEnabled = isGenAINewUIEnabledWithRCPS();

    const content = message.data?.query || message.data?.summary || message.data?.content || message.content;

    if (!type || !content) {
        return null;
    }

    const cleanContent = convertMarkdownLinksToJiraFormat(content); // Converts [text](url) → [text|url]

    return (
        <Flex css={styles.messageContainer(type)}>
            <Box css={[styles.message, styles[type](isGenAINewUIEnabled)]}>
                <Markdown
                    content={cleanContent}
                    targetWindow='new'
                />
            </Box>
        </Flex>
    );
}

const styles = {
    messageContainer: type => {
        if (type === 'sent') {
            return {
                justifyContent: 'flex-end',
                paddingLeft: '20%'
            };
        }

        return {
            paddingRight: '20%'
        };
    },
    message: {
        padding: space[3],
        borderRadius: 12,
        fontSize: fontSizes.base,
        lineHeights: lineHeights.tight,
        wordWrap: 'break-word'
    },
    sent: () => ({
        backgroundColor: colors.black,
        color: colors.white,
        borderBottomRightRadius: 0
    }),
    received: () => ({
        backgroundColor: colors.nearWhite,
        color: colors.black,
        borderBottomLeftRadius: 0
    })
};

export default wrapFunctionalComponent(Message, 'Message');
